import React from "react";
import { Divider } from "@svg/antd";
import { useIntl } from "@umijs/max";

interface SearchStateProps {
  searchValue: string;
  onSelect?: (searchValue: string, select: any, type: string) => void;
  searchCategorie?: Array<{ key: number; value: string; hightLight: string }>;
  recommendation?: string[];
  categoriesRecommend?: Array<{ key: number; value: string[] }>;
}

const SearchState: React.FC<SearchStateProps> = ({
  searchValue,
  onSelect,
  searchCategorie = [],
  recommendation = [],
  categoriesRecommend = [],
}) => {
  const { formatMessage } = useIntl();

  const handleSelect = (item: any, type: string) => {
    if (onSelect) {
      onSelect(searchValue, item, type);
    }
  };

  const handleMouseDown = (
    event: React.MouseEvent<HTMLDivElement>,
    item: any,
    type: string
  ) => {
    event.preventDefault();
    handleSelect(item, type);
  };

  return (
    <div className="dropdown-container">
      {/* 搜索范围 */}
      {searchCategorie.length > 0 && (
        <>
          <div className="search-scope-section">
            {searchCategorie.map((category) => {
              const parts = category.value.split(category.hightLight);
              return (
                <div
                  key={category.key}
                  className="list-item"
                  onMouseDown={(event) =>
                    handleMouseDown(event, category, "searchCategorie")
                  }
                >
                  {parts?.[0]}
                  <span className="search-text">{category.hightLight}</span>
                  {parts?.[1]}
                </div>
              );
            })}
          </div>
        </>
      )}
      {/* 类目推荐 */}
      {categoriesRecommend.length > 0 && (
        <>
          <div className="section-divider">
            <Divider className="section-divider-item" />
          </div>
          <div className="category-recommend-section">
            <div className="secondary">{formatMessage({ id: "类目推荐" })}</div>
            {categoriesRecommend.map((category, index) => (
              <div
                key={index}
                className="category-recommend-item"
                onMouseDown={(event) =>
                  handleMouseDown(event, category, "categoriesRecommend")
                }
              >
                <div className="category-link">
                  {category?.value?.map((item, idx) => {
                    return (
                      <span key={`${index}-${idx}`}>
                        {formatMessage({ id: item })}
                        {idx < category?.value?.length - 1 && " > "}
                      </span>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* 猜你想搜 */}
      {recommendation.length > 0 && (
        <>
          <div className="section-divider">
            <Divider className="section-divider-item" />
          </div>
          <div className="guess-search-section">
            <div className="secondary">{formatMessage({ id: "猜你想搜" })}</div>
            <div className="recommendation-list">
              {recommendation.map((item) => {
                if (searchValue && item.includes(searchValue)) {
                  const parts = item.split(searchValue);
                  return (
                    <div
                      key={item}
                      className="list-item"
                      onMouseDown={(event) =>
                        handleMouseDown(event, item, "recommendation")
                      }
                    >
                      {parts?.[0]}
                      <span className="search-text">{searchValue}</span>
                      {parts?.[1]}
                    </div>
                  );
                }
                return (
                  <div
                    key={item}
                    className="list-item"
                    onMouseDown={(event) =>
                      handleMouseDown(event, item, "recommendation")
                    }
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchState;
